import LnkPanel from 'utils/lnk-panel';
import 'styles/main.scss';

function App() {
  return (
    <div className="app">
      <LnkPanel />
    </div>
  );
}

export default App;
